// API helpers for the v2.1 GitHub connection (workspace-level, read-only).
import axios from 'axios';

const base = (wId) => `/bot/api/w/${wId}/github`;

export const getGithubConnection = (wId) => axios.get(`${base(wId)}/connection`);

// Returns { url } to the GitHub App install page (carries a signed state).
// `from` is echoed into the signed state so the callback knows where to return
// the user (e.g. 'onboarding' → back to the wizard instead of Settings).
export const startGithubInstall = (wId, from) =>
  axios.get(`${base(wId)}/install`, { params: from ? { from } : {} });

export const listGithubRepos = (wId) => axios.get(`${base(wId)}/repos`);

export const disconnectGithub = (wId) =>
  axios.delete(`${base(wId)}/connection`);
